import { Tag } from '../../../cdl/Tag/Tag';
import { Tooltip } from '../../../cdl/Tooltip/Tooltip';
import { translate } from '../../../common/helpers/translate.helper';
import { Characters } from '../../../common/helpers/unicode.helper';

interface RfqVendorReferenceDisplayProps {
    offerIds?: string[];
    vendorReferences?: string[];
    chosenOfferVendorReference?: string | null;
}

export const RfqVendorReferenceDisplay = ({
    offerIds,
    vendorReferences,
    chosenOfferVendorReference,
}: RfqVendorReferenceDisplayProps) => {
    const offerCount = offerIds?.length ?? 0;
    const availableVendorReferences = vendorReferences?.filter(Boolean) ?? [];
    const tooltip = availableVendorReferences.join(', ');

    if (typeof chosenOfferVendorReference === 'string') {
        return chosenOfferVendorReference || Characters.EN_DASH;
    }

    if (offerCount <= 1) {
        return availableVendorReferences[0] || Characters.EN_DASH;
    }

    if (tooltip) {
        return (
            <Tooltip showArrow align="center" side="top" label={tooltip}>
                <Tag variant="default">{translate('offer.multipleOffers')}</Tag>
            </Tooltip>
        );
    }

    return <Tag variant="default">{translate('offer.multipleOffers')}</Tag>;
};
